import { render, staticRenderFns } from "./BaseROInput.vue?vue&type=template&id=1c42e91a&scoped=true&"
import script from "./BaseROInput.vue?vue&type=script&lang=js&"
export * from "./BaseROInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseROInput.vue?vue&type=style&index=0&id=1c42e91a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42e91a",
  null
  
)

export default component.exports